var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleStarUpper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 148,
    viewBox: "0 0 498 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_197_1204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.999 80.6579L395.162 23.1992L497.999 -53.3686V-53.6322L497.208 -54.5547L393.58 22.672L392.789 23.3309L497.34 81.844L497.999 80.6579Z",
    fill: "url(#paint0_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.001 -54.5555L385.408 -72.083L384.617 -72.2148L393.582 24.648L498.001 -53.3694V-54.5555ZM385.936 -70.7652L496.024 -53.633L394.637 22.0123L385.936 -70.7652Z",
    fill: "url(#paint1_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 102.93L95.6179 143.784L56.4608 37.8277L56.0653 36.7734L-3 101.349V102.93ZM93.3766 141.543L-1.81342 102.008L55.6697 39.4092L93.3766 141.543Z",
    fill: "url(#paint2_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.60447 -2.76562L-3 -2.23848V-1.44776L54.8787 38.3517L-3 101.345V102.268L-2.47263 102.663L56.3289 38.6152L56.8563 38.0881L-2.60447 -2.76562Z",
    fill: "url(#paint3_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.704 48.6318L54.4844 38.6161L128.052 -36.7656L111.704 48.6318ZM57.2531 37.6936L110.781 47.0504L126.075 -32.6803L57.2531 37.6936Z",
    fill: "url(#paint4_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 -2.89432V-1.44468L55.9334 39.0137L129.106 -35.9727L-3 -2.89432ZM55.8016 37.3005L-1.41789 -1.97182L124.887 -33.6005L55.8016 37.3005Z",
    fill: "url(#paint5_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6943 145.231L54.7461 37.4297L111.834 47.4454L94.6943 145.231ZM56.8556 39.0111L94.2987 140.091L110.383 48.3679L56.8556 39.0111Z",
    fill: "url(#paint6_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6406 143.518L110.648 46.5234L111.571 47.3141L195.95 123.75L93.6406 143.518ZM111.703 49.1592L95.3546 141.805L193.313 122.959L111.703 49.1592Z",
    fill: "url(#paint7_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.16 124.675L109.727 47.448L111.045 47.1844L203.203 31.2383L195.16 124.675ZM112.627 48.2387L194.106 121.907L201.884 32.8197L112.627 48.2387Z",
    fill: "url(#paint8_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.383 48.6341L126.599 -35.9727L203.991 32.4244L110.383 48.6341ZM127.39 -33.4687L111.965 47.0526L200.958 31.6337L127.39 -33.4687Z",
    fill: "url(#paint9_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.412 32.8179L202.016 32.5543L124.625 -35.7109L271.893 -7.77228L202.412 32.8179ZM129.239 -33.6024L202.676 31.2364L268.333 -7.11335L129.239 -33.6024Z",
    fill: "url(#paint10_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.565 108.332L201.355 31.8958L270.573 -8.5625L306.565 108.332ZM203.729 32.1594L304.06 105.037L269.782 -6.45392L203.729 32.1594Z",
    fill: "url(#paint11_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.973 124.144L202.015 30.8398L306.961 107.144L193.973 124.144ZM203.07 33.212L195.291 122.563L303.533 106.222L203.07 33.212Z",
    fill: "url(#paint12_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.983 107.937L304.719 106.883L269.254 -8.42969L395.427 22.9354L304.983 107.937ZM271.1 -6.58468L305.642 105.434L392.658 23.5943L271.1 -6.58468Z",
    fill: "url(#paint13_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.769 24.7787L300.238 -57.0605L385.804 -72.3477L385.936 -71.6887L394.769 24.7787ZM303.271 -56.2697L393.187 21.6159L384.617 -70.7662L303.271 -56.2697Z",
    fill: "url(#paint14_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.481 24.5158L269.121 -7.11287L269.648 -7.90358L301.686 -57.7188L302.213 -57.1916L396.481 24.5158ZM271.231 -7.90358L391.471 21.8801L301.95 -55.742L271.231 -7.90358Z",
    fill: "url(#paint15_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 -8.95703V1.84943C0.0323682 1.84943 2.40553 -0.522709 2.40553 -3.55379C2.40553 -6.58487 0.0323682 -8.95703 -3 -8.95703Z",
    fill: "url(#paint16_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.001 75.9141C497.869 75.9141 497.869 75.9141 497.738 75.9141C494.705 75.9141 492.332 78.2862 492.332 81.3173C492.332 84.3484 494.705 86.7205 497.738 86.7205C497.869 86.7205 497.869 86.7205 498.001 86.7205V75.9141Z",
    fill: "url(#paint17_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.976 28.6033C396.961 28.6033 399.381 26.1842 399.381 23.2001C399.381 20.216 396.961 17.7969 393.976 17.7969C390.99 17.7969 388.57 20.216 388.57 23.2001C388.57 26.1842 390.99 28.6033 393.976 28.6033Z",
    fill: "url(#paint18_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.651 106.618C310.651 103.587 308.278 101.215 305.245 101.215C302.213 101.215 299.84 103.587 299.84 106.618C299.84 109.649 302.213 112.021 305.245 112.021C308.278 112.021 310.651 109.649 310.651 106.618Z",
    fill: "url(#paint19_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.948 32.0282C207.948 28.9972 205.575 26.625 202.542 26.625C199.51 26.625 197.137 28.9972 197.137 32.0282C197.137 35.0593 199.51 37.4315 202.542 37.4315C205.575 37.4315 207.948 35.0593 207.948 32.0282Z",
    fill: "url(#paint20_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.038 123.356C200.038 120.325 197.664 117.953 194.632 117.953C191.6 117.953 189.227 120.325 189.227 123.356C189.227 126.387 191.6 128.76 194.632 128.76C197.664 128.76 200.038 126.387 200.038 123.356Z",
    fill: "url(#paint21_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.581 47.8407C116.581 44.8097 114.207 42.4375 111.175 42.4375C108.143 42.4375 105.77 44.8097 105.77 47.8407C105.77 50.8718 108.143 53.244 111.175 53.244C114.207 53.244 116.581 50.8718 116.581 47.8407Z",
    fill: "url(#paint22_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8384 142.727C99.8384 139.696 97.4652 137.324 94.4329 137.324C91.4005 137.324 89.0273 139.696 89.0273 142.727C89.0273 145.759 91.4005 148.131 94.4329 148.131C97.4652 148.131 99.8384 145.627 99.8384 142.727Z",
    fill: "url(#paint23_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 96.8672V107.674C0.0323682 107.674 2.40553 105.302 2.40553 102.27C2.40553 99.3711 0.0323682 96.8672 -3 96.8672Z",
    fill: "url(#paint24_linear_197_1204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2056 38.2236C61.2056 35.1925 58.8324 32.8203 55.8001 32.8203C52.7677 32.8203 50.3945 35.1925 50.3945 38.2236C50.3945 41.2546 52.7677 43.6268 55.8001 43.6268C58.8324 43.6268 61.2056 41.1228 61.2056 38.2236Z",
    fill: "url(#paint25_linear_197_1204)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_1204",
    x1: 441.436,
    y1: 112.243,
    x2: 532.281,
    y2: -33.1322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_1204",
    x1: 437.044,
    y1: 46.2359,
    x2: 487.585,
    y2: -76.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_1204",
    x1: 42.5988,
    y1: 167.633,
    x2: 107.729,
    y2: 43.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_1204",
    x1: 24.6763,
    y1: 126.16,
    x2: 101.764,
    y2: 35.3611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_197_1204",
    x1: 88.5006,
    y1: 67.6644,
    x2: 142.43,
    y2: -28.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_197_1204",
    x1: 58.0829,
    y1: 55.726,
    x2: 86.3707,
    y2: -47.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_197_1204",
    x1: 81.1422,
    y1: 169.257,
    x2: 160.671,
    y2: 81.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_197_1204",
    x1: 140.946,
    y1: 165.135,
    x2: 195.287,
    y2: 46.2204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_1204",
    x1: 152.948,
    y1: 145.499,
    x2: 207.096,
    y2: 33.1139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_197_1204",
    x1: 153.665,
    y1: 67.4904,
    x2: 199.578,
    y2: -37.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_197_1204",
    x1: 192.718,
    y1: 48.0909,
    x2: 214.407,
    y2: -48.6047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_197_1204",
    x1: 250.002,
    y1: 134.384,
    x2: 322.101,
    y2: -0.242858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_197_1204",
    x1: 246.216,
    y1: 144.939,
    x2: 293.729,
    y2: 25.5727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_197_1204",
    x1: 327.594,
    y1: 133.872,
    x2: 391.608,
    y2: -10.1271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_197_1204",
    x1: 343.947,
    y1: 46.4254,
    x2: 401.193,
    y2: -69.1661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_197_1204",
    x1: 328.009,
    y1: 42.8435,
    x2: 362.59,
    y2: -68.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_197_1204",
    x1: -0.500598,
    y1: 4.25788,
    x2: 7.50154,
    y2: -4.04646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_197_1204",
    x1: 494.953,
    y1: 89.129,
    x2: 502.932,
    y2: 80.4447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_197_1204",
    x1: 393.569,
    y1: 31.0118,
    x2: 399.832,
    y2: 18.0138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_197_1204",
    x1: 304.839,
    y1: 114.43,
    x2: 311.101,
    y2: 101.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_197_1204",
    x1: 202.136,
    y1: 39.8399,
    x2: 208.398,
    y2: 26.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_197_1204",
    x1: 194.225,
    y1: 131.168,
    x2: 200.488,
    y2: 118.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_197_1204",
    x1: 110.768,
    y1: 55.6524,
    x2: 117.031,
    y2: 42.6544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_197_1204",
    x1: 94.0261,
    y1: 150.539,
    x2: 100.289,
    y2: 137.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_197_1204",
    x1: -0.500598,
    y1: 110.082,
    x2: 7.50154,
    y2: 101.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_197_1204",
    x1: 55.3933,
    y1: 46.0352,
    x2: 61.6558,
    y2: 33.0372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3BD4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_1204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 318,
    fill: "white",
    transform: "translate(-3 -170)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleStarUpper);
export default __webpack_public_path__ + "static/media/moduleStarUpper.b6c9ac0ec4372e813f6e3af136d06f8c.svg";
export { ForwardRef as ReactComponent };